import { httpGatewayService } from "@/modules/common/services";
import axios from "axios";
import moment from "moment";
import {storageService} from "../../common/services";
import getInterceptors from '@/modules/common/services/interceptors.js';
import {BusinessDateFormats} from '@/modules/common/filters'

// const HTTP2 = axios.create({
//   baseURL: window.vue_config.VUE_APP_NOTIFICATION_CENTER_URL,
//   headers: {
//     "X-AUTHORIZATION": 'Bearer eyJhbGciOiJSUzUxMiJ9.eyJpYXQiOjE2NjE4NjI2NjYsImV4cCI6MTY2MTg2NjI2NiwiaXNzIjoidzZtNmcyNmNwb2xpY3RjMTpzdGFmZiIsImJlbG9uZ3MiOiJncG5hMzkxcGxsbHdnMTRuOmJ1c2luZXNzOzE4OmRpcmVjdG9yeSIsInNjcCI6ImFsbCJ9.Noz09zqMbVv-XUgpHPrtLkXB3oasvmdxDrsgyEuu63W79oC1C9tbJd_QBcFPWHNrW6HTjkFPip6iGO9Lk13jKbXusVA6MXzOl8fnapKLFjSNPTshybyhWO9mIWttd9om_PTaetpCTVPVRR-iKsqkmw3RAd00XHlWLWPT5Nj6rtPm61nZwxYTqt_-A7oCG9Jc5-JVlJ8qDG0CuoMz41AaampNpBEFtPf-goJu4YHGXW9YvwrwOkfNOy6GxEF0aqCgn0xoPS37g_wwaaTBQTEtIelFLg66y3Bdsf8oZ8KU8Ys8i54W1KpfZ9p-6uLrtye60N4BA4ghvLjSF4ga9oxv3A',
//     "content-type": "application/json"
//   }
// });

const LOCAL_STORAGE_EXPIRY_TTL = 1000 * 60 * 60 * 12 // equals 12 hours in milliseconds
const DEFAULT_POLLING_TIMEOUT = 30000
const baseRoute = 'business/notificationscenter'
const notificationsRoute = 'v1/notifications'
const notificationsCounterRoute = 'v1/notificationscounters'
const typesRoute = 'v1/notificationstype'
const translationsRoute = 'v1/translations'
const notificationsMetadataRoute = 'v1/notificationsmetadata'
let cancelTokenSource

const HTTP = axios.create({
  baseURL: window.vue_config.VUE_APP_NOTIFICATION_CENTER_URL,
  withCredentials: false
});

const serviceInterceptors = getInterceptors(HTTP);

HTTP.interceptors.request.use(
  serviceInterceptors.REQUEST.onFulfilled,
  serviceInterceptors.REQUEST.onRejected,
);

HTTP.interceptors.response.use(
  serviceInterceptors.RESPONSE.onFulfilled,
  serviceInterceptors.RESPONSE.onRejected,
);

const getIsNewNotificationCounter = async (currentCounter, staffUid) => {
  cancelTokenSource = axios.CancelToken.source();
  return await HTTP.get(`${baseRoute}/${notificationsCounterRoute}/${currentCounter}/${staffUid}?filter[is_new][eq]=1`,
    {
      headers: {
        "Content-Security-Policy": "connect-src 'none'; script-src 'none'"
      },
      cancelToken: cancelTokenSource.token,
      timeout: DEFAULT_POLLING_TIMEOUT
    })
    .then(res => {
      return res.data?.data?.counters?.new_notifications_count
    })
}

const getNotifications = async (numberOfDays, per_page, page) => {
  const minDate = moment().subtract(numberOfDays, 'days').format('YYYY-MM-DD');
  const getParams = {
    'filter[created_at][gte]' : minDate,
    'sort' : 'created_at:desc',
    'per_page' : per_page,
    'page' : page
  }
  return await httpGatewayService.get(`${baseRoute}/${notificationsRoute}`,
    { ...getParams })
    .then(res => {
      return res.data?.notifications
    })
}

const getNotificationsTypes = async () => {
  return await httpGatewayService.get(`${baseRoute}/${typesRoute}`)
    .then(res => {
      return res.data?.notifications_types
    })
}

const getNotificationsMetadata = async () => {
  return await httpGatewayService.get(`${baseRoute}/${notificationsMetadataRoute}`)
    .then(res => {
      return res.data?.notifications_metadata
    })
}

const getNotificationsTranslations = async () => {
  return await httpGatewayService.get(`${baseRoute}/${translationsRoute}`)
    .then(res => {
      return res.data?.notifications_translations
    })
}

const fetchData = async (localStorageKey, getDataFromDBfunc) => {
  return (storageService.getWithExpiry(localStorageKey) || await fetchDataFromDB(localStorageKey, getDataFromDBfunc))
}

const getNewestData = async (relevantUids, localStorageKey, getDataFromDBfunc) => {
  const fetchedData = await fetchData(localStorageKey, getDataFromDBfunc);
  const currentExistingUids = fetchedData.map(data => data.uid)
  const allUidsExists = relevantUids.every(uid => currentExistingUids.includes(uid))
  if(!allUidsExists){
    return await fetchDataFromDB(localStorageKey, getDataFromDBfunc)
  }
  return fetchedData
}

const fetchDataFromDB = async (localStorageKey, getDataFromDBfunc) => {
  const data = await getDataFromDBfunc()
  storageService.saveWithExpiry(localStorageKey, data, LOCAL_STORAGE_EXPIRY_TTL)
  return data
}

const resetNotificationCounter = async () => {
  return await httpGatewayService.put(`${baseRoute}/${notificationsRoute}/?filter[is_new][eq]=1`,
    {
      is_new:false
    })
    .then(res => res.data)
}

const setNotificationReadStatus = async (notification_uid, status) => {
  return await httpGatewayService.put(`${baseRoute}/${notificationsRoute}/${notification_uid}`,
    {
      read:status
    })
    .then(res => res.data)
}

const setAllNotificationsAsRead = async () =>{
  return await httpGatewayService.put(`${baseRoute}/${notificationsRoute}?filter[read][eq]=0`,
    {
      read:true
    })
    .then(res => res.data)
}

const cancelRequest = () => {
  if (cancelTokenSource) {
    cancelTokenSource.cancel('cancel');
  }
}

const getMetadataFromLocalStorage = async (allNotifications) =>{
  const currentExistingMetadataUids = [...new Set(allNotifications.map(notification => notification.notification_metadata_uid))]
  return await getNewestData(currentExistingMetadataUids, 'notificationsMetadata', getNotificationsMetadata)
}

const getAllTypesFromLocalStorage = async(allMetadata) =>{
  const currentExistingTypeUids = [...new Set(allMetadata.map(metadata => metadata.notification_type_uid))]
  return await getNewestData(currentExistingTypeUids, 'notificationsTypes', getNotificationsTypes)
}

const getAvatarByType = (type) =>{
  switch (type){
    case 'clients':
      return require('@/assets/images/notification_pane/clients_thumbnail.svg');
    case 'marketing':
      return require('@/assets/images/notification_pane/marketing_thumbnail.svg');
    case 'calendar':
      return require('@/assets/images/notification_pane/calendar_thumbnail.svg');
    case 'payments':
      return require('@/assets/images/notification_pane/payment_thumbnail.svg');
    case 'booking':
      return require('@/assets/images/notification_pane/booking_thumbnail.svg');
    case 'scheduling':
      return require('@/assets/images/notification_pane/booking_thumbnail.svg');
    case 'teamchat':
      return require('@/assets/images/notification_pane/team_chat_thumbnail.svg');
    case 'advertising':
      return require('@/assets/images/notification_pane/advertising_thumbnail.svg');
    case 'group_events':
      return require('@/assets/images/notification_pane/group_event.svg');
    case 'reviews':
      return require('@/assets/images/notification_pane/review.svg');
    case 'messages':
      return require('@/assets/images/notification_pane/messages.svg');
    case 'documents':
      return require('@/assets/images/notification_pane/document.svg');
    case 'social':
      return require('@/assets/images/notification_pane/social_content.svg');
    default:
      return ''
  }
}

const buildBodyAppointmentBookingReminder = (notification) => {
  const timeRegEx = /^(2[0-3]|[01][0-9]):?([0-5][0-9])$/

  const splitedBody = notification.text_sent.body.split(' ')
  const timeIndex = splitedBody.findIndex(curr => timeRegEx.test(curr))
  const formattedTime = BusinessDateFormats.time(new Date(`2022 ${splitedBody[timeIndex]}`))
  splitedBody[timeIndex] = formattedTime
  const body = splitedBody.join(" ")
  return body
}

const buildTitleAppointmentBookingReminder = (notification) => {
  let title;

  const splittedTitle = notification.text_sent.title.split(' ')
  const res = BusinessDateFormats.time_at(new Date(`${splittedTitle[splittedTitle.length - 2]} ${splittedTitle[splittedTitle.length - 1]}`))
  const splitByComma = res.split(', ')
  const splitBySpace = res.split(' ')

  if(splitByComma.length > 1){
    const formattedDate = `${splitByComma[0]}, ${splitByComma[1]}`
    const newArray = splittedTitle.splice(0, splittedTitle.length - 2)
    newArray.push(formattedDate)
    title = newArray.join(" ")
  }
  else if(splitBySpace.length > 1){
    const formattedDate = `${splitBySpace[0]} ${splitBySpace[1]} ${splitBySpace[2]}`
    const newArray = splittedTitle.splice(0, splittedTitle.length - 2)
    newArray.push(formattedDate)
    title = newArray.join(" ")
  }

  return title
}

export const notificationCenterService = {
  getIsNewNotificationCounter,
  getNotifications,
  getNotificationsTypes,
  getNotificationsMetadata,
  getNotificationsTranslations,
  getNewestData,
  fetchData,
  fetchDataFromDB,
  getMetadataFromLocalStorage,
  getAllTypesFromLocalStorage,
  resetNotificationCounter,
  cancelRequest,
  setNotificationReadStatus,
  setAllNotificationsAsRead,
  getAvatarByType,
  buildTitleAppointmentBookingReminder,
  buildBodyAppointmentBookingReminder

}
